import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { isWeb } from '../../../../constants';
export const styles = StyleSheet.create({
    section: {
        marginTop: rem(8),
        marginBottom: rem(16),
    },
    categorySection: {
        marginBottom: rem(16),
    },
    itemWithContentTitle: {
        marginBottom: rem(8),
    },
    webPadding: {
        ...(isWeb && {
            padding: rem(8),
        }),
    },
    walkthroughTitleContainer: {
        marginHorizontal: 0,
    },
    walkthroughSection: {
        marginBottom: 0,
    },
});
